export default __webpack_public_path__ + "images/00853f321537ddd3d0924262276117fd-SpinningLogo.gif";